<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import StrSorgular from "@/models/StrSorgular";
export default {
  mixins: [Api, Sabit, StrSorgular],
  page: {
    title: "Sorgular",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
  },
  data() {
    return {
      title: this.$t("StrSorgular.Title"),
      items: [
        {
          text: this.$t("StrSorgular.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrSorgular.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      Filter: {
        Sorguadi: "", 
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      Deneme: {
        fileName: "str/GetBirimButce.frx",
        fileFormat: "pdf",
        parameters: [
          { parametreKey: "adi", parametreVal: "adı dır" },
          { parametreKey: "soyadi", parametreVal: "soyadı dırrr" },
        ],
      },
      Yaz: "",
    };
  },
  methods: {
    Get() {


      let Filter = "";

      if (this.Filter.Sorguadi != "" && this.Filter.Sorguadi != null) {
        Filter = Filter + "&Sorguadi=" + this.Filter.Sorguadi;
      }

      this.ActionsFilterGet({ Service: "StrSorgular", Page: this.Page, Filter:Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
    deneme() {
      axios({
        url: "https://localhost:9001/api/v1/GenericReport",
        method: "POST",
        responseType: "blob",
        data: this.Deneme,
      })
        .then((response) => {
          //YENİ SEKMEDE AÇMAK İÇİN
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);

          window.open(url);
          /* DİREK İNDİRMEK İÇİN

           var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                     var fileLink = document.createElement('a');
   
                     fileLink.href = fileURL;
                     fileLink.setAttribute('download', 'file.pdf');
                     document.body.appendChild(fileLink);
   
                     fileLink.click();
 */
        })
        .catch((error) => error.response.data);
    },

  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <div class="search-box me-2 mb-2 d-inline-block">
                 
                  <div class="position-relative">
                     <input @input="Filter.Sorguadi.length >= 3 || Filter.Sorguadi.length == 0 ? Get() : ''" 
                    v-model="Filter.Sorguadi" type="text" class="form-control" placeholder="Arama..." />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                     <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.StrSorgular @click="(DataUpdate = StrSorgularData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i>{{ $t("StrSorgular.Page.YeniKayitEkle") }}</button>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("StrSorgular.Table.Sorguadi") }}</th>
                      <th>{{ $t("StrSorgular.Table.Sorgu") }}</th>
                      <th>{{ $t("StrSorgular.Table.Parametreler") }}</th>
                     <!-- <th>{{ $t("StrSorgular.Table.Aktif") }}</th>-->
                      <th>{{ $t("StrSorgular.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Sorguadi }}</th>
                      <td>{{ Data.Sorgu }}</td>
                      <td>{{ Data.Parametreler }}</td>
                     <!-- <td>
                        <div class="action-is w-100 d-flex justify-content-center align-items-center">
                          <i v-if="Data.Aktif" class="fas fas fa-check"></i>
                          <i v-if="!Data.Aktif" class="fas fas fa-times"></i>
                        </div>
                      </td>-->
                      <td style="width: 20px;">
                        <div class="action-is w-100 d-flex justify-content-center align-items-center">
                          <i class="fas fa-pencil-alt" v-b-modal.StrSorgular @click="(DataUpdate = Data), (AddEdit = 'Edit')"></i>
                          <i class="fas fa-trash-alt" @click="Delete('StrSorgular', Data.Id)"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" />
    </Layout>
  </Loader>
</template>
